// extracted by mini-css-extract-plugin
module.exports = {"root":"spinner_root__3UgEH","shadow":"spinner_shadow__3girx","background":"spinner_background__1WZ1f","move":"spinner_move__12cHZ"};